import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useSupplier } from '../../../../hooks/useSupplier';
import { usePayableTable } from '../../table/hooks/usePayableTable';

import SectionInfoHeader from '../../../../components/common/SectionInfoHeader';
import SvgIcon from '../../../../components/SvgIcon/SvgIcon';
import QuickAddSupplier from '../../../../components/QuickAdd/Supplier/QuickAddSupplier';
import SimpleSearchSelect from '../../../../components/Forms/Input/SimpleSearchSelect';

import SearchSelectionCard from './SearchSelectionCard/SearchSelectionCard';

const SupplierSelector = () => {
  const navigate = useNavigate();

  const { handlerGetSuppliersForDropdown, suppliersDropdown, saveSupplier } =
    useSupplier();

  const { fetchPendingPayablesBySupplier, pendingSupplierPayables } =
    usePayableTable();

  const [selectedSupplierId, setSelectedSupplierId] = useState<number | null>(
    null
  );

  const [selectedPayableId, setSelectedPayableId] = useState<number | null>(
    null
  );

  /**
   * 🔥 cargar proveedores
   */
  useEffect(() => {
    handlerGetSuppliersForDropdown();
  }, []);

  /**
   * 🔥 cargar cuentas del proveedor
   */
  useEffect(() => {
    if (!selectedSupplierId) return;

    fetchPendingPayablesBySupplier(selectedSupplierId);
  }, [selectedSupplierId]);

  /**
   * 🔥 navegación al pago
   */
  const handlePayableSelect = (item: {
    id: number;
    number: string;
    issueDate: string;
    dueDate: string;
    totalAmount: number;
    paidAmount: number;
    balance: number;
    status: string;
    daysOverdue: number;
  }) => {
    setSelectedPayableId(item.id);

    navigate(`/finance/cxp/register-payment/${item.id}`);
  };

  /**
   * 🔥 búsqueda backend
   */
  const handleSearchPayables = async (search: string) => {
    if (!selectedSupplierId) return;

    await fetchPendingPayablesBySupplier(selectedSupplierId, search);
  };

  return (
    <div className="px-6 py-6">
      <SectionInfoHeader
        icon={<SvgIcon name="user" />}
        title="Pagar a Proveedores"
        description="Busca y selecciona un proveedor para registrar el pago."
        color="bg-danger"
      />

      {/* Quick Add */}
      <div className="mb-4">
        <QuickAddSupplier
          onReload={handlerGetSuppliersForDropdown}
          onSupplierCreated={saveSupplier}
        />
      </div>

      {/* Proveedor */}
      <div className="mb-5 max-w-xl">
        <SimpleSearchSelect
          label="Proveedor"
          name="supplier"
          iconKey="user"
          selectedValue={selectedSupplierId}
          onSelect={(option) => {
            setSelectedSupplierId(option.id);
            setSelectedPayableId(null);
          }}
          options={suppliersDropdown}
          required
        />
      </div>

      {/* Cuentas */}
      <SearchSelectionCard
        title="Seleccionar cuenta"
        description="Busca una cuenta pendiente para registrar el pago"
        label="Buscar cuenta"
        name="payable"
        iconKey="invoice"
        options={pendingSupplierPayables}
        selectedValue={selectedPayableId}
        onSelect={handlePayableSelect}
        onSearch={handleSearchPayables}
        listTitle="Cuentas disponibles"
        emptyMessage="No hay cuentas por pagar disponibles"
        disabled={!selectedSupplierId}
        required
      />
    </div>
  );
};

export default SupplierSelector;
